<template>
  <div
    class="general-wrapper"
    v-if="!!waiter"
  >
    <Header
      parent="workers"
      v-if="ui_state == 'profile'"
    >
      <template #title>
        {{ waiter.name || $t("worker_profile.new_ph") }}
      </template>
      <template #actions>
        <div class="iqos-tooltip-helper-box">
          <BaseButton
            variant="secondary"
            :color="waiter.personal_telegram_id ? 'green-5' : 'v1-grey-5'"
            icon="telegram"
            @click="show_telegram_tooltip = !show_telegram_tooltip"
            size="md"
          />

          <IQOSTooltip
            @close="show_telegram_tooltip = false"
            title="Telegram bot"
            :qrLink="directTelegramLink"
            v-if="show_telegram_tooltip"
          >
            {{  $t("worker_profile.bot_panel_comment") }}
          </IQOSTooltip>
        </div>
        <BaseButton
          variant="secondary"
          color="v1-grey-10"
          class="ml-8"
          size="md"
          icon="bullet-list"
          iconPosition="left"
          @click="ui_state = 'orders'"
        >
          {{ $t("worker_profile.orders_history") }}
        </BaseButton>
        <BaseButton
          variant="secondary"
          color="v1-grey-10"
          size="md"
          class="ml-8"
          icon="bullet-list"
          iconPosition="left"
          @click="ui_state = 'tips'"
        >
          {{ $t("worker_profile.tips_history") }}
        </BaseButton>
      </template>
    </Header>

    <Header v-else-if="ui_state == 'orders'">
      <template #parent>
        <span
          class="span-link qrw-heading-xs v1-grey-7-color"
          @click="$router.push('/workers')"
        >
          {{ waiter.name }} <img src="../assets/arrow-right.svg" /></span>
      </template>
      <template #title>
        {{ $t("worker_profile.orders_history") }}
      </template>
    </Header>

    <Header
      parent="workers"
      v-else-if="ui_state == 'tips'"
    >
      <template #title>
        {{ $t("worker_profile.tips_history") }} ({{ waiter.name }})
      </template>
    </Header>

    <PageContainer v-if="ui_state == 'profile'">
      <div class="iqos-grid">
        <div class="iqos-column">
          <WorkersProfileEditor
            ref="profilePanel"
            :waiter="waiter"
            @saved="onProfileUpdated"
          />
          <WorkerAttachedModes
            :waiter="waiter"
            @toggle="onAttachMode"
            v-if="
              cafe.modes.preorder ||
              cafe.modes.delivery ||
              cafe.modes.reserve ||
              cafe.modes.inside ||
              cafe.modes.hotels
            "
          />
          <WorkerSchedule
            :waiter="waiter"
            @saved="onProfileUpdated"
          />
          <WorkerAttachedTables
            :waiter="waiter"
            @saved="onAttachTablesChanged"
            v-if="cafe.modes.inside && waiter.attached_modes.inside"
          />
        </div>
        <div class="iqos-column">
          <WorkerNotificationPanel :waiter="waiter" />
          <!-- <WorkerTipMethods :waiter="waiter" @saved="onTipMethodsChanged" /> -->
          <WorkersTipsBalance
            :waiter="waiter"
            @history="ui_state = 'tips'"
            @payout="onPayout"
          />
        </div>
      </div>
    </PageContainer>

    <div v-else-if="ui_state == 'orders'">
      <WorkerOrdersHistory :waiter="waiter" />
    </div>

    <div v-else-if="ui_state == 'tips'">
      <WorkerTipsHistory :waiter="waiter" />
    </div>
  </div>
</template>

<script>
import WaitersAPI from '@/api/waiters'

import WorkersProfileEditor from '@/components/workers/WorkersProfileEditor.vue'
import WorkersTipsCard from '@/components/workers/WorkerTipsCard.vue'
import WorkerNotificationPanel from '@/components/workers/WorkerNotificationPanel.vue'
import WorkersTipsBalance from '@/components/workers/WorkerTipsBalance.vue'
import WorkerAttachedTables from '@/components/workers/WorkerAttachedTables.vue'
import WorkerSchedule from '@/components/workers/WorkerSchedule.vue'

import WorkerOrdersHistory from '@/components/workers/WorkerOrdersHistory.vue'
import WorkerTipsHistory from '@/components/workers/WorkerTipsHistory.vue'
import WorkerAttachedModes from '@/components/workers/WorkerAttachedModes.vue'

import WorkerTipMethods from '@/components/workers/WorkerTipMethods.vue'

import DashboardButton from '@/components/DashboardButton.vue'

export default {
  data() {
    return {
      waiter: null,

      ui_state: 'profile',

      show_telegram_tooltip: false,

      deeplink_id: null
    }
  },
  methods: {
    fetchWaiter() {
      WaitersAPI.getWaiterById(this.$route.params.id)
        .then(data => {
          if (data.waiter) {
            this.waiter = data.waiter
          } else {
            this.$router.push('/workers')
          }

          this.fetchDeeplink()
        })
        .catch(error => {
          alert(error)
        })
    },
    updateWaiter() {
      if (!this.waiter.name || !this.waiter.pin) return

      WaitersAPI.updateWaiter(this.waiter._id, this.waiter)
        .then(data => {
          this.waiter = data.waiter

          this.$refs.profilePanel.markSaved()
        })
        .catch(error => {
          if ((error = 'register_exists')) {
            this.$store.dispatch('showError', 'waiter_pin_exists')
            return
          }

          alert(error)
        })
    },
    onProfileUpdated(data) {
      this.waiter = data
      this.updateWaiter()
    },
    onAttachTablesChanged(tables) {
      this.waiter.attached_tables = tables
      this.updateWaiter()
    },
    onTipsCardChanged(value) {
      this.waiter.tips_card_number = value
      this.updateWaiter()
    },
    onTipMethodsChanged(value) {
      this.waiter.tipping_methods = value.tipping_methods
      this.waiter.pay_receiver_id = value.pay_receiver_id

      this.updateWaiter()
    },
    onPayout(new_waiter) {
      this.waiter = new_waiter
    },
    onAttachMode(mode) {
      this.waiter.attached_modes[mode] = !this.waiter.attached_modes[mode]

      this.updateWaiter()
    },
    fetchDeeplink() {
      WaitersAPI.getDeeplink(this.waiter._id)
        .then(data => {
          this.deeplink_id = data.deeplink
        })
        .catch(error => {})
    }
  },
  mounted() {
    this.fetchWaiter()

    this.$store.dispatch('fetchPayReceivers')
  },
  computed: {
    cafe() {
      return this.$store.state.cafe
    },
    directTelegramLink() {
      if (!this.deeplink_id) return ''
      return `https://t.me/QRWaiterPersonalBot?start=${this.deeplink_id}`
    }
  },
  components: {
    WorkersProfileEditor,
    WorkersTipsCard,
    WorkerNotificationPanel,
    WorkersTipsBalance,
    WorkerAttachedTables,
    DashboardButton,
    WorkerOrdersHistory,
    WorkerTipsHistory,
    WorkerAttachedModes,
    WorkerSchedule,
    WorkerTipMethods
  }
}
</script>

<style></style>
